module.exports = __webpack_public_path__ + "static/media/image1.01c0cd8a.png";